document.addEventListener("DOMContentLoaded", function() {
    const subjectField = document.querySelector('select[name="id_contact"]'),
        orderDiv = document.querySelector('#orderReference');
        orderField = document.querySelector('[name="id_order"]');
    subjectField.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        if (contactForm.requiredOrderSubjects.includes(selectedOption.value)) {
            orderDiv.classList.remove('d-none');
            orderField.setAttribute('required', 'required');
        } else {
            orderDiv.classList.add('d-none');
            orderField.removeAttribute('required');
        }
    });
    subjectField.dispatchEvent(new Event('change'));
    if (document.getElementById('faqSearch')) {
        let inputTimer;
        const faqSearchInput = document.getElementById('faqSearch'),
            accordionItems = document.querySelectorAll('.accordion-item'),
            accordionBlocks = document.querySelectorAll('.accordionFaq'),
            noResultsElem = document.getElementById('noResults');
            inputDelay = 300,
            applyFilter = () => {
                console.log('Applying filter');
                const filter = faqSearchInput.value.toLowerCase();
                if (filter === '') {
                    accordionItems.forEach(function(item) {
                        $(item).show();
                    });
                    accordionBlocks.forEach(function(block) {
                        $(block).show();
                        const h3 = document.querySelector(`h3[data-for="${block.id}"]`);
                        $(h3).show();
                    });
                    $(noResultsElem).hide();
                    return;
                }
                accordionItems.forEach(function(item) {
                    const question = item.querySelector('.accordion-button').textContent.toLowerCase();
                    if (question.includes(filter)) {
                        $(item).show();
                    } else {
                        $(item).hide();
                    }
                });
                accordionBlocks.forEach(function(block) {
                    const visibleItems = Array.from(block.querySelectorAll('.accordion-item')).filter(item => $(item).is(':visible')),
                        h3 = document.querySelector(`h3[data-for="${block.id}"]`);
                    if (visibleItems.length === 0) {
                        $(block).hide();
                        $(h3).hide();
                    } else {
                        $(block).show();
                        $(h3).show();
                    }
                });
                const anyVisible = Array.from(accordionItems).some(item => $(item).is(':visible'));
                if (!anyVisible) {
                    $(noResultsElem).show();
                }
                else {
                    $(noResultsElem).hide();
                }
            };

        faqSearchInput.addEventListener('input', function() {
            inputTimer = clearTimeout(inputTimer);
            inputTimer = setTimeout(applyFilter, inputDelay);
        });
    }
    const fakeFileInput = document.querySelector('#fileUpload'),
        realFileInput = document.querySelector('input[name="fileUpload[]"]');

    fakeFileInput.addEventListener('click', function(e) {
        e.preventDefault();
        realFileInput.click();
    });
    realFileInput.addEventListener('change', function() {
        const fileNames = Array.from(realFileInput.files).map(file => file.name).join('<br/>');
        if (fileNames && fileNames.length > 0) {
            document.querySelector('span.nbFiles').innerHTML = fileNames;
            $("span.noFile").hide();
        }
        else {
            document.querySelector('span.nbFiles').innerHTML = '';
            $("span.noFile").show();
        }
    });
});
